// // HeroSection.jsx
// import { motion } from "framer-motion";
// import CountUp from "react-countup";
// import { FaChartLine, FaSmile, FaUsers } from "react-icons/fa";
// import heroImg from "../assets/19.png";
// import "../css/Together.css";

// const Stat = ({ value, label, suffix, icon }) => {
//   return (
//     <motion.div
//       className="landing-page-techvison-mz-stat-card"
//       whileHover={{ scale: 1.05 }}
//       transition={{ type: "spring", stiffness: 200 }}
//     >
//       <div className="landing-page-techvison-mz-stat-icon">{icon}</div>
//       <h2>
//         <CountUp
//           start={0}
//           end={value}
//           duration={2.5}
//           suffix={suffix || ""}
//           enableScrollSpy={true}
//         />
//       </h2>
//       <p>{label}</p>
//     </motion.div>
//   );
// };

// const HeroSection = () => {
//   return (
//     <section className="landing-page-techvison-mz-hero-container">
//       {/* Left image */}
//       <motion.div
//         className="landing-page-techvison-mz-hero-left"
//         initial={{ opacity: 0, x: -80 }}
//         animate={{ opacity: 1, x: 0 }}
//         transition={{ duration: 1 }}
//       >
//         <img src={heroImg} alt="Community Support" />
//       </motion.div>

//       {/* Right content */}
//       <motion.div
//         className="landing-page-techvison-mz-hero-right"
//         initial={{ opacity: 0, x: 80 }}
//         animate={{ opacity: 1, x: 0 }}
//         transition={{ duration: 1 }}
//       >
//         <h1>
//           Empowering{" "}
//           <motion.span
//             className="landing-page-techvison-mz-animated-word"
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.5, duration: 1 }}
//           >
//             financial futures
//           </motion.span>{" "}
//           together
//         </h1>
//         <p>
//           With a commitment to integrity, expertise, and personalized service,
//           we strive to build lasting relationships based on trust and mutual
//           success.
//         </p>

//         <motion.button
//           whileHover={{ scale: 1.05 }}
//           whileTap={{ scale: 0.95 }}
//           className="landing-page-techvison-mz-cta-btn"
//         >
//           Know more about us
//         </motion.button>

//         {/* Dynamic Stats */}
//         <div className="landing-page-techvison-mz-stats">
//           <Stat
//             value={99}
//             suffix="%"
//             label="Client Satisfaction"
//             icon={<FaSmile />}
//           />
//           <Stat
//             value={150}
//             suffix="%"
//             label="Company Growth"
//             icon={<FaChartLine />}
//           />
//           <Stat
//             value={120}
//             label="Weekly New Users"
//             icon={<FaUsers />}
//           />
//         </div>
//       </motion.div>
//     </section>
//   );
// };

// export default HeroSection;

import { motion } from "framer-motion";
import CountUp from "react-countup";
import { FaRegHandshake, FaArrowRight, FaUsers, FaLeaf } from "react-icons/fa";
import heroImg from "../assets/19.png"; 
import "../css/Together.css";

const Stat = ({ value, label, suffix, icon }) => {
  return (
    <motion.div
      className="mfi-stat-card"
      whileHover={{ y: -10 }}
      transition={{ type: "spring", stiffness: 300 }}
    >
      <div className="mfi-stat-icon">{icon}</div>
      <div className="mfi-stat-info">
        <h3>
          <CountUp end={value} duration={3} suffix={suffix || ""} enableScrollSpy={true} />
        </h3>
        <p>{label}</p>
      </div>
    </motion.div>
  );
};

const HeroSection = () => {
  return (
    <section className="mfi-hero-wrapper">
      <div className="mfi-hero-grid">
        
        {/* Content Side */}
        <motion.div
          className="mfi-hero-content"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <span className="mfi-badge">✨ Empowering Rural Entrepreneurs</span>
          <h1>
            Growing <span className="mfi-gradient-text">Communities</span> Through Financial Inclusion
          </h1>
          <p>
            Join over 12,000 small business owners who are transforming their lives 
            with ethical micro-loans, secure savings, and expert financial literacy.
          </p>

          <div className="mfi-btn-group">
            <motion.button 
              whileHover={{ scale: 1.05 }} 
              className="mfi-btn-primary"
            >
              Get Started <FaArrowRight />
            </motion.button>
            <button className="mfi-btn-secondary">Learn Our Impact</button>
          </div>

          <div className="mfi-stats-row">
            <Stat value={12} suffix="k+" label="Active Borrowers" icon={<FaUsers />} />
            <Stat value={98} suffix="%" label="Repayment Rate" icon={<FaRegHandshake />} />
            <Stat value={100} suffix="%" label="Secure Funds" icon={<FaLeaf />} />
          </div>
        </motion.div>

        {/* Image Side */}
        <motion.div
          className="mfi-hero-visual"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1 }}
        >
          <div className="mfi-image-frame">
            <img src={heroImg} alt="Microfinance Impact" />
            {/* Floating Trust Card */}
            <motion.div 
              className="mfi-floating-card"
              animate={{ y: [0, -15, 0] }}
              transition={{ repeat: Infinity, duration: 4 }}
            >
               <FaLeaf className="card-icon" />
               <div>
                 <strong>Community First</strong>
                 <p>Ethical Lending</p>
               </div>
            </motion.div>
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default HeroSection;